





















import { Component, Vue } from 'vue-property-decorator';
import Tabs from '@/components/tabs/Tabs.vue';
import Tab from '@/components/tabs/Tab.vue';
import FunctionsTab from '@/components/tabs/FunctionsTab.vue';
import IdeTab from '@/components/tabs/IdeTab.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    FunctionsTab,
    IdeTab,
    Tab,
    Tabs,
  },
  computed: mapGetters(['openFiles']),
})
export default class CodeVault extends Vue {
  private tabIndex = 0;

  private switchTab(newTab: number): void {
    this.tabIndex = newTab;
  }

  private close(): void {
    this.tabIndex -= 1;
  }
}
